import React from 'react'
import Particles from "react-tsparticles";
function Particle() {
    return (
        <div>
            <Particles
        id="tsparticles"
        // init={this.particlesInit}
        // loaded={this.particlesLoaded}
        options={{
          background: {
            color: "#000"
          },
          detectRetina: true,
          fpsLimit: 60,
          interactivity: {
            detectsOn: "canvas",
            events: {
              resize: true
            }
          },
          particles: {
            color: {
              value: "#fff"
            },
            number: {
              density: {
                enable: true,
                area: 1080,
                factor : 1000
              },
              limit: 0,
              value: 400
            },
            opacity: {
              animation: {
                enable: true,
                minimumValue: 0.05,
                speed: 1,
                sync: false,
                count : 0,
                startValue : 0.5,
              },
              random: {
                enable: true,
                minimumValue: 0.05
              },
              value: 1
            },
            shape: {
              type: "circle"
            },
            size: {
              random: {
                enable: true,
                minimumValue: 0.5
              },
              value: 1
            }
          }
        }}
      />
        </div>
    )
}

export default Particle
